class Ground {
    constructor(scene,xPosition) {
        this.sprites = [0,1,1,1,1,2,2,2,2,3,3,3]
        this.spriteIndex = Math.floor(Math.random() * 12);
        this.scene = scene;
        this.sprite = scene.physics.add.sprite(xPosition,780, 'ground', this.sprites[this.spriteIndex])
            .setScale(1)
            .setSize(192, 36)
            .setCollideWorldBounds(true) 
            .setDepth(1)
            this.sprite.body.customBoundsRectangle.left = -1000;
            this.sprite.body.customBoundsRectangle.right = 2000;
            this.update(this.scene.state.xVelocity);

            // this.collider = scene.physics.add.collider(
            //     scene.player.sprite,
            //     this.sprite,
            //     null,
            //     null,
            //     this
            //   );
    }

    

    update(xVelocity) {

        if (!this.isDead && this.scene.state.started) { 
            this.sprite.setVelocityX(xVelocity); // causing inconsistent cactus speeds?
        }

        else {
            this.sprite.setVelocityX(0);
        }

    }

    stop() {
        this.sprite.setVelocityX(0);
    } 

}

export default Ground; 